import { CANCEL_MODAL_EVENT, CLOSE_MODAL_EVENT, CONFIRM_MODAL_EVENT, OPEN_MODAL_EVENT } from "../../../components/preLeaveModalComponent/constants"

export const STEP_EVENT_NAME = {
    1: "step_reason",
    2: "step_personal_details",
    3: "step_confirmation"
}
export const STEP_DESCRIPTION = {
    1: "reason",
    2: "personalDetails",
    3: "confirmation"
}

export const TEALIUM = {
    sectionFamily: "banking",
    sectionCategory: "products",
    sectionName: "accounts",
    interactionType: "funnel",
    serviceType: "productCancellation",
    processType: "cancelAccount",
}

export const OPEN_MOTIVE_DROPDOWN_EVENT = "OPEN_MOTIVE_DROPDOWN_EVENT";
export const CLOSE_MOTIVE_DROPDOWN_EVENT = "CLOSE_MOTIVE_DROPDOWN_EVENT";
export const SELECT_MOTIVE_EVENT = "SELECT_MOTIVE_EVENT";
export const CLICK_MOTIVE_INPUT_EVENT = "CLICK_MOTIVE_INPUT_EVENT";
export const CLICK_PERSONAL_DATA_LINK_EVENT = "CLICK_PERSONAL_DATA_LINK_EVENT";
export const DISPLAY_SUCCESS_EVENT = "DISPLAY_SUCCESS_EVENT";
export const DISPLAY_ERROR_EVENT = "DISPLAY_ERROR_EVENT";
export const CLICK_GO_TO_ACCOUNTS_LINK_EVENT = "CLICK_GO_TO_ACCOUNTS_LINK_EVENT";

export const TEALIUM_EVENTS = {
    next: {
        data: true,
        action: 'continue',
        format: 'button',
        component: 'lowerNavigation',
        element: 'next',
        eventCategory: 'cuenta/cancelación',
        eventAction: 'lowerNavigation',
        eventLabel: 'next'
    },
    previous: {
        data: true,
        action: 'return',
        format: 'button',
        component: 'lowerNavigation',
        element: 'previous',
        eventCategory: 'cuenta/cancelación',
        eventAction: 'lowerNavigation',
        eventLabel: 'previous'
    },
    cancel: {
        data: true,
        action: 'cancel',
        format: 'link',
        component: 'lowerNavigation',
        element: 'cancel',
        eventCategory: 'cuenta/cancelación',
        eventAction: 'clickLink',
        eventLabel: 'cancel'
    },
    finish: {
        data: true,
        action: 'click',
        format: 'button',
        component: 'lowerNavigation',
        element: 'sendRequest',
        eventCategory: 'cuenta/cancelación',
        eventAction: 'lowerNavigation',
        eventLabel: 'sendRequest'
    }
}

const CATEGORY_ACTION_EVENT = 'modifyPersonalDetails'

export const CANCEL_FLOW_MODAL = {
    [OPEN_MODAL_EVENT]: {
        action: "open",
        format: "modal",
        component: `modal/${CATEGORY_ACTION_EVENT}`,
        element: "full",
        accionEvento: CATEGORY_ACTION_EVENT,
        etiquetaEvento: "open",
        categoriaEvento: 'cuenta/cancelación'
    },
    [CLOSE_MODAL_EVENT]: {
        action: "close",
        format: "cross",
        component: `modal/${CATEGORY_ACTION_EVENT}`,
        element: "close",
        accionEvento: CATEGORY_ACTION_EVENT,
        etiquetaEvento: "close",
        categoriaEvento: 'cuenta/cancelación'
    },
    [CANCEL_MODAL_EVENT]: {
        action: "cancel",
        format: "link",
        component: `modal/${CATEGORY_ACTION_EVENT}`,
        element: "cancel",
        accionEvento: CATEGORY_ACTION_EVENT,
        etiquetaEvento: "cancel",
        categoriaEvento: 'cuenta/cancelación'
    },
    [CONFIRM_MODAL_EVENT]: {
        action: "click",
        format: "button",
        component: `modal/${CATEGORY_ACTION_EVENT}`,
        element: "leaveProcess",
        accionEvento: CATEGORY_ACTION_EVENT,
        etiquetaEvento: "leaveProcess",
        categoriaEvento: 'cuenta/cancelación'
    },
}

const MOTIVE_DROPDOWN_TAGGING_BASE = {
    format: "dropdown",
    component: "cancellationReason",
    element: "cancellationReason",
    eventAction: "cancellationReasonDropdown",
}

export const FLOW_STEP1_TAGGING = {
    [OPEN_MOTIVE_DROPDOWN_EVENT]: {
        ...MOTIVE_DROPDOWN_TAGGING_BASE,
        action: 'open',
        eventLabel: 'open'
    },
    [CLOSE_MOTIVE_DROPDOWN_EVENT]: {
        ...MOTIVE_DROPDOWN_TAGGING_BASE,
        action: 'close',
        eventLabel: 'close'
    },
    [SELECT_MOTIVE_EVENT]: {
        ...MOTIVE_DROPDOWN_TAGGING_BASE,
    },
    [CLICK_MOTIVE_INPUT_EVENT]: {
        action: "type",
        format: "textBox",
        component: "cancellationReason",
        element: "reason",
        eventAction: "typeTextbox",
        eventLabel: "reason"
    }
}

export const FLOW_STEP2_TAGGING = {
    [CLICK_PERSONAL_DATA_LINK_EVENT]: {
        action: "click",
        format: "link",
        component: "body",
        element: "personalDetails",
        eventAction: "clickLink",
        eventLabel: "personalDetails"
    }
}

export const FLOW_SUCCESS_STEP_TAGGING = {
    [DISPLAY_SUCCESS_EVENT]: {
        ...TEALIUM,
        eventName: "step_confirmation",
        nombrePagina: "/cancelAccount/success",
        processStep: "success",
        event_name: "step_success",
        sectionFamily: "banking",
        sectionCategory: "products",
        sectionName: "accounts",
        interactionType: "funnel",
        serviceType: "productCancellation",
        processType: "cancelAccount",
        processStep: "success",
    },
    [CLICK_GO_TO_ACCOUNTS_LINK_EVENT]: {
        action: "click",
        format: "link",
        component: "lowerNavigation",
        element: "goToAccount",
        pathname: "/myprofile/accounts",
        eventCategory: "/cancelAccount/success",
        eventAction: "lowerNavigation",
        eventLabel: "goToAccount"
    }
}

export const FLOW_ERROR_STEP_TAGGING = {
    [DISPLAY_ERROR_EVENT]: {
        ...TEALIUM,
        eventName: "step_error",
        nombrePagina: "/cancelAccount/error/notPossibleToCompleteTheRequest",
        processDetail: "notPossibleToCompleteTheRequest",
        processType: "cancelAccount",
        processStep: 'error',
        errorCategory: "notPossibleToCompleteTheRequest",
    },
    [CLICK_GO_TO_ACCOUNTS_LINK_EVENT]: {
        action: "click",
        format: "link",
        component: "lowerNavigation",
        element: "goToTheAccount",
        pathname: "/myprofile/accounts",
        eventCategory: "/cancelAccount/success",
        eventAction: "lowerNavigation",
        eventLabel: "goToTheAccount"
    }
}
